// =========================================================
// 父の日LP - jc-fathers-day.js
// 1. Countdown setInterval (data-target-date → JST 0時)
// 2. Budget / Category filter (SEC 4/6)
// Spec: spec/fathers_day_lp_spec.md §5
// =========================================================

(function () {
  'use strict';

  // ---------- 1. Countdown ----------
  const heroEl = document.querySelector('.fd-hero');
  if (heroEl) {
    const targetStr = heroEl.dataset.targetDate;
    if (targetStr) {
      const targetISO = targetStr.length === 10
        ? `${targetStr}T00:00:00+09:00`
        : targetStr;
      const target = new Date(targetISO);

      const cdDays = heroEl.querySelector('[data-cd-days]');
      const cdHours = heroEl.querySelector('[data-cd-hours]');
      const cdMins = heroEl.querySelector('[data-cd-mins]');
      const cdSecs = heroEl.querySelector('[data-cd-secs]');

      function update() {
        const diff = target - new Date();

        if (diff <= 0) {
          heroEl.classList.add('is-expired');
          if (cdDays) cdDays.textContent = '0';
          if (cdHours) cdHours.textContent = '00';
          if (cdMins) cdMins.textContent = '00';
          if (cdSecs) cdSecs.textContent = '00';
          return;
        }

        const days = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const mins = Math.floor((diff % 3600000) / 60000);
        const secs = Math.floor((diff % 60000) / 1000);

        if (cdDays) cdDays.textContent = days;
        if (cdHours) cdHours.textContent = String(hours).padStart(2, '0');
        if (cdMins) cdMins.textContent = String(mins).padStart(2, '0');
        if (cdSecs) cdSecs.textContent = String(secs).padStart(2, '0');

        if (days < 3) heroEl.classList.add('is-warning');
      }

      update();
      setInterval(update, 1000);
    }
  }

  // ---------- 2. Budget / Category filter ----------
  const productList = document.querySelector('[data-fd-product-list]');
  if (!productList) return;

  const budgetPills = document.querySelectorAll('[data-fd-budget-filter] [data-budget]');
  const catPills = document.querySelectorAll('[data-fd-cat-filter] [data-cat]');

  let currentBudget = 'all';
  let currentCat = 'all';

  function applyFilter() {
    productList.querySelectorAll('.fd-product-card').forEach(card => {
      const price = parseInt(card.dataset.price, 10);
      const tags = (card.dataset.tags || '').split(',');

      let budgetOk = true;
      if (currentBudget === 'under10k') budgetOk = price < 10000;
      else if (currentBudget === '10k-20k') budgetOk = price >= 10000 && price < 20000;
      else if (currentBudget === '20k-30k') budgetOk = price >= 20000 && price < 30000;
      else if (currentBudget === 'over30k') budgetOk = price >= 30000;

      const catOk = currentCat === 'all' || tags.includes(currentCat);
      card.style.display = (budgetOk && catOk) ? '' : 'none';
    });
  }

  budgetPills.forEach(pill => {
    pill.addEventListener('click', () => {
      budgetPills.forEach(p => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      currentBudget = pill.dataset.budget;
      applyFilter();
      const target = document.getElementById('fd-all-products');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  catPills.forEach(pill => {
    pill.addEventListener('click', () => {
      catPills.forEach(p => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      currentCat = pill.dataset.cat;
      applyFilter();
    });
  });

  // ---------- 3. FAQ accordion (pdp-accordion パターン移植) ----------
  // <details> ネイティブ挙動を活かしつつ Web Animations API で height を滑らかに開閉。
  // 排他制御なし (複数パネル同時展開 OK)。
  const FAQ_DURATION = 300;
  const FAQ_EASING = 'ease';

  document.querySelectorAll('.fd-faq-item').forEach((details) => {
    const summary = details.querySelector('.fd-faq-q');
    const body = details.querySelector('.fd-faq-body');
    if (!summary || !body) return;

    let animation = null;
    let isClosing = false;
    let isExpanding = false;

    summary.addEventListener('click', (e) => {
      e.preventDefault();
      details.style.overflow = 'hidden';

      if (isClosing || !details.open) {
        openPanel();
      } else if (isExpanding || details.open) {
        closePanel();
      }
    });

    function openPanel() {
      details.style.height = `${details.offsetHeight}px`;
      details.open = true;
      window.requestAnimationFrame(() => {
        isExpanding = true;
        const startHeight = details.offsetHeight;
        const endHeight = summary.offsetHeight + body.scrollHeight;

        if (animation) animation.cancel();

        animation = details.animate(
          { height: [`${startHeight}px`, `${endHeight}px`] },
          { duration: FAQ_DURATION, easing: FAQ_EASING }
        );
        animation.onfinish = () => onAnimationFinish(true);
        animation.oncancel = () => { isExpanding = false; };
      });
    }

    function closePanel() {
      isClosing = true;
      const startHeight = details.offsetHeight;
      const endHeight = summary.offsetHeight;

      if (animation) animation.cancel();

      animation = details.animate(
        { height: [`${startHeight}px`, `${endHeight}px`] },
        { duration: FAQ_DURATION, easing: FAQ_EASING }
      );
      animation.onfinish = () => onAnimationFinish(false);
      animation.oncancel = () => { isClosing = false; };
    }

    function onAnimationFinish(open) {
      details.open = open;
      animation = null;
      isClosing = false;
      isExpanding = false;
      details.style.height = '';
      details.style.overflow = '';
    }
  });
})();
